import axios from '../axios'

export const same = (data) => {
  return axios({
      url: '/check/same',
      method: 'get',
      params: {
        showResult: data.showResult,
        approveStatus: data.approveStatus,
        titleSimilarity: data.titleSimilarity,
        picType: data.picType,
        checkDesc: data.checkDesc,
        checkWirelessDesc: data.checkWirelessDesc,
        checkSameCode: data.checkSameCode,
        checkSameProp: data.checkSameProp,
        checkSamePartNo: data.checkSamePartNo
      }
  })
}
export const checkProp = (data) => {
  return axios({
      url: '/check/checkProp',
      method: 'post',
      data
  })
}
export const getItemScores = (data) => {
  return axios({
      url: '/check/getItemScores',
      method: 'post',
      data
  })
}

export const getScore = (data) => {
  return axios({
      url: '/check/getScore',
      method: 'get',
      data
  })
}
export const getPropRept = (data) => {
  return axios({
      url: '/check/getPropRept',
      method: 'get',
      params: {
        numIid: data
      }
  })
}




// WEBPACK FOOTER //
// ./src/http/modules/check.js